module.exports = __webpack_public_path__ + "media/images/icons/filled/control-1858ac74fcee9a6056b08c25123b03fa.svg";